// 9fbef606107a605d69c0edbcd8029e5d 
export const DEFAULT_LAZY_LOAD_CONFIG = {
  thresholdX: 200,
  thresholdY: 200,
  throttleWait: 75,
  noLazyHorizontalScroll: false,
  callback: null,
  wrapperID: null,
};

export default DEFAULT_LAZY_LOAD_CONFIG;
